<dashlet
  title="Not Sold Ballot"
  [loading]="loading"
  [noResults]="!listResults?.length && !loading"
  >
  <ng-container filter>
    <time-filter
      [DateRange]="DateRange"
      [dateSize]="dateSize"
      (onSetDateSize)="setDateSize($event)"
      (onIncrementStartDate)="incrementStartDate()"
      (onDecrementStartDate)="decrementStartDate()"
      (onStartDateToday)="startDateToday()"
      >
    </time-filter>
  </ng-container>

  @if (!!listResults?.length) {
    <ng-container data>
      <product-table
        title="Not Sold Ballot"
        [datasource]="dataSource"
        [displayedColumns]="displayedColumns"
        >
      </product-table>
      <!-- (onGuestList)="guestList($event)" -->
      <mat-paginator
        #paginator
        [pageSize]="pageSize"
        [length]="totalSize"
        [pageIndex]="currentPage"
        (page)="pageEvent = handlePage($event)"
        >
      </mat-paginator>
    </ng-container>
  }
</dashlet>
